(() => {
  // Optional review product links pointing to verified unpublished catalog items.
  const unpublishedReviewHandles = new Set(["dog-cooling-mat-pcm", "dog-cooling-mat-self-cooling-ice-silk-pad-washable-breathable-summer-dog-cooling-mat", "external-ssd-portable-fast-solid-state-drive-external-external-storage", "horse-whiskey-decanter-sculpted-glass-head", "interactive-plush-toy-robot-puppy-realistic-play-puppy-cuddly-soft", "mens-sports-watch-rugged-outdoor-adventures-durable-sports-watch", "portable-air-cooler-portable-evaporative-cooler-quiet-fan-indoor-use", "quilted-laptop-and-ins", "robot-interactive-learning-toy-for-motor-skills", "stainless-steel-lunch-box"]);
  const cleanReviewProductLinks = (root) => {
    const links = [...(root.matches?.('a.related-product[href]') ? [root] : []), ...(root.querySelectorAll?.('a.related-product[href]') || [])];
    links.forEach(link => {
      const handle = new URL(link.href, location.origin).pathname.split('/products/')[1]?.split('/')[0];
      if (!unpublishedReviewHandles.has(handle)) return;
      const label = document.createElement('span');
      label.className = link.className;
      label.dataset.unpublishedProduct = handle;
      label.append(...link.childNodes);
      link.replaceWith(label);
    });
  };
  document.addEventListener('DOMContentLoaded', () => {
    cleanReviewProductLinks(document);
    new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === 1) cleanReviewProductLinks(node);
    }))).observe(document.body, {childList:true,subtree:true});
  });

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('#sidebar-menu[open]');
    if (!menu || typeof menu.hide !== 'function' || document.querySelector('.pswp--open, cart-drawer[open], [data-celzoir-store-modal]:not([hidden])')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    menu.hide().then(() => document.querySelector('[aria-controls="sidebar-menu"]')?.focus({ preventScroll: true }));
  }, true);

  const initAnnouncement = () => {
    const bar = document.querySelector('.shopify-section--announcement-bar');
    if (!bar || bar.dataset.celzoirReady) return;
    const sentinel = document.createElement('span');
    sentinel.className = 'celzoir-announcement-sentinel';
    bar.before(sentinel);
    bar.dataset.celzoirReady = '1';
    const update = () => {
      const stuck = sentinel.getBoundingClientRect().top < 0;
      bar.classList.toggle('celzoir-announcement--stuck', stuck);
      sentinel.style.height = stuck ? '36px' : '0px';
    };
    addEventListener('scroll', update, { passive: true });
    addEventListener('resize', update, { passive: true });
    update();
  };

  const initAvailability = (widget) => {
    if (!widget || widget.dataset.celzoirReady) return;
    const modal = widget.querySelector('[data-celzoir-store-modal]');
    const opener = widget.querySelector('[data-celzoir-store-open]');
    const closer = widget.querySelector('[data-celzoir-store-close]');
    const city = widget.querySelector('[data-celzoir-store-city]');
    const country = widget.querySelector('[data-celzoir-store-country]');
    country?.addEventListener('change', () => country.form?.requestSubmit());
    const label = widget.querySelector('[data-celzoir-store-city-label]');
    const result = widget.querySelector('[data-celzoir-store-city-result]');
    let previousFocus;
    widget.dataset.celzoirReady = '1';
    const close = () => { modal.hidden = true; document.body.classList.remove('celzoir-store-modal-open'); previousFocus?.focus(); };
    opener?.addEventListener('click', () => { previousFocus = opener; modal.hidden = false; document.body.classList.add('celzoir-store-modal-open'); closer?.focus(); });
    closer?.addEventListener('click', close);
    modal?.addEventListener('click', e => { if (e.target === modal) close(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !modal.hidden) close(); });
    city?.addEventListener('change', () => { label.textContent = city.value; result.textContent = result.dataset.labelTemplate.replace('__CITY__', city.value); });
  };

  const initGallery = () => {
    document.querySelectorAll('product-gallery').forEach(gallery => {
      if (gallery.dataset.celzoirCounterReady) return;
      const items = gallery.querySelectorAll('.product-gallery__carousel > .product-gallery__media');
      if (!items.length) return;
      const counter = document.createElement('span');
      counter.className = 'celzoir-gallery-counter';
      counter.textContent = `1 / ${items.length}`;
      gallery.append(counter);
      gallery.dataset.celzoirCounterReady = '1';
      const update = () => {
        const box = gallery.getBoundingClientRect();
        let closest = 0, distance = Infinity;
        items.forEach((item, index) => { const d = Math.abs(item.getBoundingClientRect().left - box.left); if (d < distance) { distance = d; closest = index; } });
        counter.textContent = `${closest + 1} / ${items.length}`;
      };
      gallery.addEventListener('scroll', update, { passive: true });
      gallery.querySelectorAll('scroll-carousel').forEach(carousel => carousel.addEventListener('scroll', update, { passive: true }));
      requestAnimationFrame(update);
      setTimeout(update, 250);
      setTimeout(update, 800);
    });
  };

  const zoomFocusBound = new WeakSet();
  document.addEventListener('click', event => {
    const trigger = event.target.closest?.('.product-gallery__zoom-button');
    const gallery = trigger?.closest('product-gallery');
    if (!gallery || zoomFocusBound.has(gallery) || !gallery.lightBox) return;
    zoomFocusBound.add(gallery);
    gallery.lightBox.on('destroy', () => requestAnimationFrame(() => {
      const visibleTrigger = gallery.querySelector('.product-gallery__zoom-button');
      if (visibleTrigger?.isConnected && visibleTrigger.getClientRects().length) visibleTrigger.focus({ preventScroll: true });
    }));
  }, true);

  let stickyNavigationReady = false;
  const initStickyPurchaseNavigation = () => {
    const update = () => {
      const bar = document.querySelector('product-sticky-bar');
      const primary = document.querySelector('.product-info [data-block-type="buy-buttons"] button[type="submit"]');
      if (!bar || !primary) return;
      const description = document.querySelector('.product-info [data-block-type="description"], .product-info [data-block-id="cw_content"]');
      const box = description?.getBoundingClientRect();
      const pastDescriptionMiddle = !box || box.top + box.height * 0.5 < innerHeight;
      const visible = matchMedia('(max-width: 768px)').matches && primary.getBoundingClientRect().bottom < 36 && pastDescriptionMiddle;
      bar.dataset.celzoirVisible = String(visible);
      bar.setAttribute('aria-hidden', String(!visible));
    };
    update();
    if (stickyNavigationReady) return;
    stickyNavigationReady = true;
    let pending = false;
    const requestUpdate = () => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => { pending = false; update(); });
    };
    addEventListener('scroll', requestUpdate, { passive: true });
    addEventListener('resize', requestUpdate, { passive: true });
    document.addEventListener('click', event => {
      const stickyButton = event.target.closest?.('product-sticky-bar button');
      if (!stickyButton || !matchMedia('(max-width: 768px)').matches) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const primary = document.querySelector('.product-info [data-block-type="buy-buttons"] button[type="submit"]');
      const title = document.querySelector('.product-info [data-block-type="title"]');
      const price = document.querySelector('.product-info [data-block-type="price"]');
      if (!primary) return;
      const space = Math.max(0, innerHeight - 150);
      const bottom = scrollY + primary.getBoundingClientRect().bottom;
      let start = title || price;
      if (start && bottom - (scrollY + start.getBoundingClientRect().top - 48) > space && price) start = price;
      const top = start ? scrollY + start.getBoundingClientRect().top - 48 : bottom - space;
      scrollTo({ top: Math.max(0, Math.min(top, bottom - space)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      primary.focus({ preventScroll: true });
      requestUpdate();
    }, true);
  };

  const updateStock = () => document.querySelectorAll('[data-celzoir-inventory]').forEach(row => {
    const unavailable = document.querySelector('buy-buttons button[disabled]');
    row.hidden = !!unavailable;
  });

  const normalizeSaleBadges = () => {
    document.querySelectorAll('.product-info .price-list .cw-save').forEach(badge => {
      if (badge.querySelector('.celzoir-pdp-sale-label__prefix')) return;
      const match = badge.textContent.match(/(\d+)\s*%/);
      if (!match) return;
      badge.innerHTML = `<span class="celzoir-pdp-sale-label__prefix">LAST DAY |</span><span class="celzoir-pdp-sale-label__value">-${match[1]}%</span><span class="celzoir-pdp-sale-label__suffix">OFF</span>`;
    });
    document.querySelectorAll('.product-info .price-list').forEach(priceList => {
      if (priceList.dataset.celzoirSaleObserver) return;
      priceList.dataset.celzoirSaleObserver = '1';
      new MutationObserver(normalizeSaleBadges).observe(priceList, { childList: true, subtree: true, characterData: true });
    });
  };

  const normalizeContractMetrics = () => {
    document.querySelectorAll('body.template-product .product-info [data-block-type="title"] .product-title').forEach(title => title.style.setProperty('font-size', matchMedia('(max-width: 768px)').matches ? '24px' : '29px', 'important'));
    document.querySelectorAll('body.template-product .product-info [data-block-type="buy-buttons"] .button').forEach(button => {
      button.style.setProperty('font-size', '18px', 'important');
      button.style.setProperty('height', '48px', 'important');
      button.style.setProperty('min-height', '48px', 'important');
    });

  };

  const init = (scope = document) => {
    initAnnouncement();
    scope.querySelectorAll?.('[data-celzoir-store-availability]').forEach(initAvailability);
    initGallery();
    initStickyPurchaseNavigation();
    updateStock();
    normalizeSaleBadges();
    normalizeContractMetrics();
  };
  document.addEventListener('DOMContentLoaded', () => init());
  addEventListener('load', () => { normalizeSaleBadges(); normalizeContractMetrics(); setTimeout(normalizeSaleBadges, 100); setTimeout(normalizeContractMetrics, 500); setTimeout(normalizeContractMetrics, 1500); });
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('variant:change', () => { requestAnimationFrame(() => init()); });
  document.addEventListener('product:rerender', () => requestAnimationFrame(() => init()), true);
  addEventListener('resize', normalizeContractMetrics, { passive: true });
})();
